import * as XLSX from "xlsx";
import { getDecimalFormat } from "helpers/getNumberFormats";
import { setXlsxRow } from "redux/actions/xlsx/xlsxActions";
import { useDispatch } from "react-redux";
import { useSearch } from "hooks/useSearch";
import { generateRandomID } from "helpers/generateRandomID";
import { useState } from "react";
import moment from "moment";


export const useXlsxControls = () => {
  const dispatch = useDispatch()
  const {setSnackbar} = useSearch()
  const [loading, setLoading] = useState(false)
  const checkSheetKeys = (object) => {
    const sheetNames = Object.keys(object);
    const requiredKeys = ['DATOS', 'EXISTENCIAS', 'RECEPCIONES', 'SALIDAS'];
    
    for (let sheetName of requiredKeys) {
        if (!sheetNames.includes(sheetName)) {
            return false;
        }
    }
    
    return true;
  };
  
  
  const checkForNullOrUndefined = (obj) => {
    for (let key in obj) {
      if (obj[key] === null || obj[key] === undefined) {
        return false; 
      }
    }
    return true;
  }
  
  
const processXLSX = (file) => {
  try {
    setLoading(true)
    setTimeout(() => {
      if (!file) {
        setSnackbar('Error con el archivo')
        setLoading(false)
        return
      }
      const extension = file.name;
      if (!extension.includes('xlsx') && !extension.includes('xls')) {
        setSnackbar('"No es una hoja de cálculo válida"')
        setLoading(false)
        return;
      }
    
      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryString = e.target.result;
        const workbook = XLSX?.read(binaryString, { type: 'binary' });
        const sheetData = {};
        workbook.SheetNames.forEach((sheetName) => {
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false });
          const columnNames = jsonData[0];
          const objects = jsonData.slice(1).map(row => {
            const obj = {};
            columnNames.forEach((columnName, index) => {
              obj[columnName] = row[index];
            });
            return obj;
          });

          const filteredObjects = objects.filter(obj => {
            let hasInfo = false
            for (let key in obj) {
              if (obj[key] != undefined) {
                hasInfo = true;
              }
            }
            return hasInfo;
          });

          sheetData[sheetName] = filteredObjects;
        });

        const isValid = checkSheetKeys(sheetData)
        if (!isValid) return setSnackbar(`${file?.name} - No es una plantilla valida`)
        
        const validDate_RECEPCIONES = sheetData?.RECEPCIONES?.every(obj => moment(obj.FechaYHoraTransaccion).isValid())
        const validDate_EXISTENCIAS = sheetData?.EXISTENCIAS?.every(obj => moment(obj.FECHAYHORAESTAMEDICION).isValid())
        const validDate_SALIDAS = sheetData?.SALIDAS?.every(obj => moment(obj.FechaYHoraTransaccion).isValid())

        let isError = ''
        const totalReceptions = sheetData?.RECEPCIONES.reduce((acc, curr) => {
          if(curr.ValorNumerico == undefined) isError = `${file?.name} - No es una plantilla valida - RECEPCIONES con ValorNumerico vacío`
          return acc + curr.ValorNumerico
        }, 0);
        if (isError) return setSnackbar(isError)

        const stock = sheetData?.EXISTENCIAS[0]?.VolumenExistenciasMes;
        const departures = sheetData?.SALIDAS?.reduce((acc, curr) => {
          if(curr.ValorNumerico == undefined) isError = `${file?.name} - No es una plantilla valida - SALIDAS con ValorNumerico vacío`
          return acc + curr.ValorNumerico
        }, 0);
        if (isError) return setSnackbar(isError)

        let row = {
          id: generateRandomID(4),
          file: file, 
          totalReceptions: getDecimalFormat (totalReceptions),
          stock: getDecimalFormat(stock),
          departures: getDecimalFormat(departures),
          pNumber: sheetData.DATOS[0]?.NUMEROPERMISO,
          year: sheetData.DATOS[0]?.AÑO, 
          month: sheetData.DATOS[0]?.MES,
          fileName: file.name,
        }

        let validObject = checkForNullOrUndefined(row)
        if (!validObject) return setSnackbar(`${file?.name} - No es una plantilla valida`)

        if(!validDate_RECEPCIONES || !validDate_EXISTENCIAS || !validDate_SALIDAS) {
          validObject = false;
          row = {
            ...row,
            errorMessage: 'Formato incorrecto para fechas'
          }
        } 
        dispatch(setXlsxRow({...row, validFile: validObject}))
      };
      reader.readAsArrayBuffer(file);
      setLoading(false)
    }, 1000);
  } catch (error) {
    setSnackbar('Error al procesar el archivo')
    setLoading(false)
  }
}
return {loading, processXLSX}
}
